/**
 * Human-readable descriptions of the Profile-page filter selections.
 *
 * The Profiles page has four server-side filters (age, vaccination,
 * growth, gn division) plus a client-side search. PDFs and subtitles
 * use this helper to spell out what's currently applied so a printed
 * report makes its scope obvious without forcing the reader to map
 * raw UI values back to meaning.
 *
 * Input values mirror the dropdown option `value` props in
 * Components/Profiles/Profiles.jsx — keep in sync if those change.
 */

const AGE_LABEL = {
    EarlyChildhood: 'Early Childhood (0–2 yrs)',
    Preschool: 'Preschool Age (2–5 yrs)',
    SchoolAge: 'School Age (5–11 yrs)',
};

const VACC_LABEL = {
    Overdue: 'Overdue',
    Due: 'Due',
    Upcoming: 'Upcoming (next 14 days)',
    'Up to Date': 'Up to Date',
};

/**
 * @param {{age?: string, vacc?: string, growth?: string, gn?: string, search?: string}} f
 * @returns {string[]} ordered list of human-readable filter lines.
 *                    Empty array means "no filter applied".
 */
export function describeFilters(f = {}) {
    const out = [];
    const { age, vacc, growth, gn, search } = f;
    if (age && age !== 'All' && AGE_LABEL[age]) out.push(`Age: ${AGE_LABEL[age]}`);
    if (vacc && vacc !== 'All' && VACC_LABEL[vacc]) out.push(`Vaccination: ${VACC_LABEL[vacc]}`);
    if (growth && growth !== 'All') out.push(`Growth Status: ${growth}`);
    if (gn && gn !== 'All') out.push(`GN Division: ${gn}`);
    const q = (search || '').trim();
    if (q) out.push(`Search: "${q}"`);
    return out;
}

/** Single-line summary for tight UI spots (page subtitle, tooltip). */
export function filterSummaryLine(f) {
    const lines = describeFilters(f);
    return lines.length === 0 ? 'All registered children' : lines.join(' · ');
}